import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Plus, Trash } from "lucide-react";

function createData(id, name, calories, fat, carbs, protein) {
  return { id, name, calories, fat, carbs, protein };
}

export default function SellasTable() {
  const [rows, setrow] = useState([
    createData(0, "Frozen yoghurt", 159, 6.0),
    createData(1, "Frozen yoghurt", 159, 6.0),
    createData(2, "Frozen yoghurt", 159, 6.0),
  ]);

  const [size, setsize] = useState("");
  const [Quantity, setquantity] = useState("");
  const [mrp, setmrp] = useState("");

  const handleAddRow = () => {
    const data = {
      id: rows.length + 1,
      name: size,
      calories: Quantity,
      fat: mrp,
    };

    if (size === "" || Quantity === "" || mrp === "") return;
    else setrow([...rows, data]);

    setsize("");
    setquantity("");
    setmrp("");
  };

  const [add, setadd] = useState(true);
  const [edit, setedit] = useState(true);
  const [rowdata, setrowdata] = useState(0);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const deleteEmployee = id => {
    return setrow([...rows.filter(item => item.id !== id)]);
  };

  return (
    <div>
      <div className="w-[70%] mx-10 mt-4 flex flex-row items-end justify-end">
        <TableContainer>
          <Table
            sx={{ maxWidth: edit === true ? 746 : 640 }}
            aria-label="simple table"
            className="rounded-sm">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 bg-[#EAEAEA]"
                  style={{ fontFamily: "Outfit" }}>
                  Size
                </TableCell>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 bg-[#EAEAEA]"
                  style={{ fontFamily: "Outfit" }}>
                  Quantity
                </TableCell>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 bg-[#EAEAEA]"
                  style={{ fontFamily: "Outfit" }}>
                  MRP (₹)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.name}>
                  <TableCell
                    scope="row"
                    align="center"
                    className="border-r-[1px] border-zinc-400">
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    className="border-r-[1px] border-zinc-400">
                    {row.calories}
                  </TableCell>
                  <TableCell
                    align="center"
                    className="border-r-[1px] border-zinc-400">
                    {row.fat}
                  </TableCell>
                  <TableCell
                    align="center"
                    className=" cursor-pointer"
                    style={{ display: edit === true ? "inline-block" : "none" }}
                    onClick={() => {
                      setrowdata(row.name);
                      deleteEmployee(row.id);
                    }}>
                    <Trash color="red" size={18} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div
          className={`flex flex-row  ${
            edit === true || add === true ? "hidden " : ""
          }`}>
          <button
            className="border-2 border-purple-700 rounded-md px-3 py-2 text-[2.2vh] font-medium font-outfit text-[#5652B0] flex items-center justify-center flex-row"
            onClick={() => {
              setadd(true);
              setedit(true);
            }}>
            <Plus /> <span className="px-2">Add</span>
          </button>
        </div>
      </div>

      <div
        className={`mx-[2.52222vw] mt-4 flex items-center justify-center ${
          add === false ? "hidden  w-[20%]" : "w-[65%] "
        }`}>
        <div className="w-[85%] flex flex-row">
          <div className="bg-[#F5F6F8] rounded-lg px-4 flex w-[53%] py-2 flex-row items-center h-[65%] allProductSearchBoxContainer ">
            <input
              type="text"
              placeholder="Enter Size..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
              value={size}
              onChange={e => {
                setsize(e.target.value);
              }}
            />
          </div>
          <div className="bg-[#F5F6F8] rounded-lg py-2 px-2 flex w-[36%] mx-2 flex-row items-center h-[65%]  allProductSearchBoxContainer  ">
            <input
              type="text"
              placeholder="Quantity..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
              value={Quantity}
              onChange={e => {
                setquantity(e.target.value);
              }}
            />
          </div>
          <div className="bg-[#F5F6F8] rounded-lg py-2 px-2 flex w-[34%] flex-row items-center h-[65%]  allProductSearchBoxContainer">
            <input
              type="text"
              placeholder="MRP (₹)..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
              value={mrp}
              onChange={e => {
                setmrp(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="mx-2 w-[15%]  flex items-start justify-centers">
          <button
            className="bg-[#5652B0] rounded-md px-6 py-2 text-[18px] font-medium font-outfit text-[#fff] flex items-center justify-center flex-row"
            onClick={handleAddRow}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
